"use strict";
(() => {
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };

  // node_modules/js-cookie/dist/js.cookie.js
  var require_js_cookie = __commonJS({
    "node_modules/js-cookie/dist/js.cookie.js"(exports, module) {
      (function(global, factory) {
        typeof exports === "object" && typeof module !== "undefined" ? module.exports = factory() : typeof define === "function" && define.amd ? define(factory) : (global = global || self, function() {
          var current = global.Cookies;
          var exports2 = global.Cookies = factory();
          exports2.noConflict = function() {
            global.Cookies = current;
            return exports2;
          };
        }());
      })(exports, function() {
        "use strict";
        function assign(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key2 in source) {
              target[key2] = source[key2];
            }
          }
          return target;
        }
        var defaultConverter = {
          read: function(value) {
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
          },
          write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
          }
        };
        function init(converter, defaultAttributes) {
          function set(key2, value, attributes) {
            if (typeof document === "undefined") {
              return;
            }
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") {
              attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            }
            if (attributes.expires) {
              attributes.expires = attributes.expires.toUTCString();
            }
            key2 = encodeURIComponent(key2).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            value = converter.write(value, key2);
            var stringifiedAttributes = "";
            for (var attributeName in attributes) {
              if (!attributes[attributeName]) {
                continue;
              }
              stringifiedAttributes += "; " + attributeName;
              if (attributes[attributeName] === true) {
                continue;
              }
              stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key2 + "=" + value + stringifiedAttributes;
          }
          function get(key2) {
            if (typeof document === "undefined" || arguments.length && !key2) {
              return;
            }
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for (var i = 0; i < cookies.length; i++) {
              var parts = cookies[i].split("=");
              var value = parts.slice(1).join("=");
              if (value[0] === '"') {
                value = value.slice(1, -1);
              }
              try {
                var foundKey = defaultConverter.read(parts[0]);
                jar[foundKey] = converter.read(value, foundKey);
                if (key2 === foundKey) {
                  break;
                }
              } catch (e) {
              }
            }
            return key2 ? jar[key2] : jar;
          }
          return Object.create({
            set,
            get,
            remove: function(key2, attributes) {
              set(key2, "", assign({}, attributes, {
                expires: -1
              }));
            },
            withAttributes: function(attributes) {
              return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter2) {
              return init(assign({}, this.converter, converter2), this.attributes);
            }
          }, {
            attributes: { value: Object.freeze(defaultAttributes) },
            converter: { value: Object.freeze(converter) }
          });
        }
        var api = init(defaultConverter, { path: "/" });
        return api;
      });
    }
  });

  // src/_includes/customers-v2/customers-helpers.js
  var require_customers_helpers = __commonJS({
    "src/_includes/customers-v2/customers-helpers.js"(exports, module) {
      "use strict";
      var Cookie = require_js_cookie();
      function ajax(options) {
        if (!options)
          return;
        const xhr = new XMLHttpRequest();
        xhr.open(options.method, options.url);
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
        xhr.setRequestHeader("Accept", "application/json, text/javascript, */*");
        if (options.needAuthorization) {
          const token = getToken();
          token && xhr.setRequestHeader("Authorization", "Bearer " + token);
        }
        xhr.withCredentials = true;
        xhr.onreadystatechange = function() {
          if (xhr.readyState === 4) {
            if (xhr.status === 0 && xhr.statusText === "") {
              let response = "";
              try {
                response = JSON.parse(xhr.responseText);
              } catch (e) {
                console.error("json parse error!");
              }
              const status = xhr.status;
              if (typeof options.fail === "function")
                options.fail(response, status);
            }
          }
        };
        xhr.onload = function() {
          typeof options.always === "function" && options.always();
          if (xhr.status === 200 && xhr.responseText) {
            const response = JSON.parse(xhr.responseText);
            if (!response.error) {
              if (typeof options.done === "function")
                options.done(response);
            } else if (response.error === 403) {
            } else if (response.error) {
              if (typeof options.fail === "function")
                options.fail(response);
            }
          } else if (xhr.responseText, xhr.status) {
            let response = "";
            try {
              response = JSON.parse(xhr.responseText);
            } catch (e) {
              console.error("json parse error!");
            }
            const status = xhr.status;
            if (typeof options.fail === "function")
              options.fail(response, status);
          }
        };
        xhr.addEventListener("progress", function(event) {
          if (event.lengthComputable) {
            var percentComplete = event.loaded / event.total;
          }
        }, false);
        if (options.method.toUpperCase() === "GET") {
          xhr.send();
        } else {
          xhr.send(decodeURI(options.param));
        }
      }
      function setUserEmail($userEmail) {
        Cookie.set("user_email", $userEmail, { expires: 0.04166 });
      }
      function getUserEmail() {
        return Cookie.get("user_email");
      }
      function removeUserEmail() {
        Cookie.remove("user_email");
      }
      function setVerificationCode($verificationCode) {
        Cookie.set("verification_code", $verificationCode, { expires: 0.04166 });
      }
      function getVerificationCode() {
        return Cookie.get("verification_code");
      }
      function removeVerificationCode() {
        Cookie.remove("verification_code");
      }
      function setToken($token) {
        Cookie.set("login_token", $token, { expires: 1 });
        setUserId($token);
      }
      function getToken() {
        return Cookie.get("login_token");
      }
      function removeToken() {
        Cookie.remove("login_token");
      }
      function setUserId($token) {
        if (!$token)
          return;
        const strings = $token.split(".");
        const userinfo = JSON.parse(decodeURIComponent(escape(window.atob(strings[1].replace(/-/g, "+").replace(/_/g, "/"))))) || {};
        if (!userinfo.uuid)
          return;
        Cookie.set("user_id", userinfo.uuid, { expires: 365 * 2 });
      }
      function setMultipass($token) {
        Cookie.set("mtp", $token);
      }
      function getMultipass() {
        return Cookie.get("mtp");
      }
      function removeMultipass() {
        Cookie.remove("mtp");
      }
      function getParams(param) {
        return searchParams().get(param);
      }
      function searchParams() {
        const encodeUrl = new URL(window.self.location.href.replace("#edit-profile", encodeURIComponent("#edit-profile")).replace("#referral-page", encodeURIComponent("#referral-page")).replace("#invites", encodeURIComponent("#invites")).replace("#waiting-list", encodeURIComponent("#waiting-list")).replace("&allow_verify_code", encodeURIComponent("&allow_verify_code")).replace("&allow_participate", encodeURIComponent("&allow_participate")).replace("?allow_participate", encodeURIComponent("?allow_participate")).replace("?allow_verify_code", encodeURIComponent("?allow_verify_code")).replace("&accessory", encodeURIComponent("&accessory")).replace("&step", encodeURIComponent("&step")).replace("&has_invites", encodeURIComponent("&has_invites")));
        const search = new URLSearchParams(encodeUrl.search);
        return search;
      }
      function redirectTo($multipass) {
        const url = spliceParams($multipass);
        window.location.href = url;
      }
      function spliceParams($multipass) {
        let redirect_to = getParams("redirect_to");
        let change = getParams("change");
        if (redirect_to && change) {
          if ($source && callback && isAllowed(callback)) {
            var redirectUrl = redirect_to + "?source=" + $source + "&callback=" + callback + "&change=" + change;
            if (return_to && isAllowed(return_to)) {
              var redirectUrl = redirect_to + "?source=" + $source + "&callback=" + callback + "&change=" + change + "&return_to" + return_to;
            }
          } else {
            var redirectUrl = redirect_to;
          }
        } else {
          if ($multipass) {
            var redirectUrl = document.querySelector("._as-callback").value + "/multipass/" + $multipass;
          } else {
            var redirectUrl = document.querySelector("._as-return-to").value;
          }
        }
        return redirectUrl;
      }
      function isAllowed(url) {
        const link = new URL(url);
        if (link.host.endsWith("fastgrowth-elegoo.myshopify.com") || link.host.endsWith("elegoo.com") || link.host.endsWith("elegoo-uk.myshopify.com") || link.host.endsWith("elegoo-ca.myshopify.com") || link.host.endsWith("eu.elegoo.com") || link.host.endsWith("au.elegoo.com")) {
          return true;
        } else {
          return false;
        }
      }
      function goToPage(path, param) {
        const url = getUrl(path, param);
        window.location.href = url;
      }
      function getUrl(path, param) {
        const search = searchParams();
        for (key in param) {
          search.set(key, param[key]);
        }
        const origin = window.self.location.origin;
        if (path && path.includes("https://")) {
          var url = path + "?" + search;
        } else {
          var url = origin + path + "?" + search;
        }
        return url;
      }
      function logoutManual() {
        return new Promise((resolve, reject) => {
          fetch("/account/logout", {
            method: "GET",
            credentials: "same-origin"
          }).then((response) => {
            if (response.ok)
              resolve(response);
            else
              reject(new Error("Logout failed"));
          }).catch((error) => {
            reject(error);
          });
        });
      }
      function getClientTime() {
        return Math.floor(new Date().getTime() / 1e3);
      }
      module.exports = {
        ajax,
        setToken,
        getToken,
        removeToken,
        setUserEmail,
        getUserEmail,
        removeUserEmail,
        setVerificationCode,
        getVerificationCode,
        removeVerificationCode,
        setUserId,
        getParams,
        redirectTo,
        goToPage,
        getUrl,
        setMultipass,
        getMultipass,
        removeMultipass,
        searchParams,
        isAllowed,
        getClientTime,
        spliceParams,
        logoutManual
      };
    }
  });

  // src/_includes/customers-v2/logout.js
  var helpers = require_customers_helpers();
  function Logout() {
  }
  Logout.prototype = {
    constructor: Logout,
    init: function() {
      this.syncLoginStatus();
      this.$logoutBtn = document.querySelectorAll(".as-logout-btn");
      this.listenClick();
      this.clearCookie();
    },
    syncLoginStatus() {
      if (document.querySelector("._as-login-flag") != null && document.body.classList.contains('template-redirect')) {
        const loginToken = helpers.getToken();
        if (!Boolean(loginToken)) {
          helpers.logoutManual().then(() => {
            location.reload();
          }).catch(() => {
            window.location.href = "/account/logout";
          });
        }
      }
    },
    clearCookie: function() {
      let currentUrl = window.self.location.href;
      if (currentUrl.includes("/account/logout")) {
        helpers.removeToken();
        helpers.removeMultipass();
        helpers.removeUserEmail();
        helpers.removeVerificationCode();
        localStorage.removeItem("user_identify_flag");
      }
    },
    listenClick: function() {
      if (this.$logoutBtn.length > 0) {
        this.$logoutBtn.forEach((item) => {
          item.addEventListener("click", (event) => {
            helpers.removeToken();
            helpers.removeMultipass();
            helpers.removeUserEmail();
            helpers.removeVerificationCode();
            localStorage.removeItem("user_identify_flag");
          });
        });
      }
    }
  };
  new Logout().init();
})();
/*! js-cookie v3.0.0 | MIT */
